(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('RightConfigurationService', ['$http', RightConfigurationServiceFn]);

    /* main right configuration service */
    function RightConfigurationServiceFn($http) {
        var baseUrl = '/api/rights/';

        var service = {
            deleteRight: deleteRight,
            updateActive: updateActive,
            save: save,
            getReceivedAgendas: getReceivedAgendas,
            getReleasedAgendas: getReleasedAgendas
        };

        return service;

        /* delete right */
        function deleteRight(rightId, selectedClientId) {
            return $http.delete(baseUrl + rightId + '/' + selectedClientId).then(function (response) {
                return response.data;
            });
        }
        
        /* update right active */
        function updateActive(rightId, selectedClientId, active) {
            return $http.put(baseUrl + rightId + '/' + selectedClientId + '/' + active).then(function (response) {
                return response.data;
            });
        }

        /* save right */
        function save(selectedClientId, userId, agendaId, active, initiatorId) {
            return $http.post(baseUrl + selectedClientId, { userId, agendaId, active, initiatorId }).then(function (response) {
                return response.data;
            });
        }

        /* get the own released agenda configuration for the given user */
        function getReleasedAgendas(userId) {
            return $http.get(baseUrl + 'users/' + userId + '/released').then(function (response) {
                return response.data;
            });
        }

        /* get the received agendas for the given user */
        function getReceivedAgendas(userId) {
            return $http.get(baseUrl + 'users/' + userId + '/received').then(function (response) {
                return response.data;
            });
        }
    }
})();